import { render, staticRenderFns } from "./CourseManager.vue?vue&type=template&id=14f470dc&scoped=true"
import script from "./CourseManager.vue?vue&type=script&lang=js"
export * from "./CourseManager.vue?vue&type=script&lang=js"
import style1 from "./CourseManager.vue?vue&type=style&index=1&id=14f470dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f470dc",
  null
  
)

export default component.exports